const slugFromTitle = (title: string = '') =>
  title
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

// The in-app URL for a blog or featured article. Prefer the stored slug: the
// server 301s any other slug to it, so a derived one is only a fallback.
export const contentPath = (
  type: 'blog' | 'article',
  id: number,
  slug: string | undefined,
  title: string
) => `/${type}/${slug || slugFromTitle(title)}/${id}`;
